import { ZigzagEvent } from '@common/app-manager';
import { isZigzag } from '@common/device-manager';
import { Toast } from '@common/overlay-manager';

/**
 * 앱/웹 환경에 따라 적절한 토스트 메시지를 보여줍니다.
 * @param message 표시할 메시지
 * @param duration 토스트 표시 시간 (기본값: 1500ms)
 */
export const showToast = (message: string, duration = 1500) => {
  if (isZigzag()) {
    ZigzagEvent.tt(message);
  } else {
    Toast.show(message, duration);
  }
};

